import { useCallback, useEffect, useState } from 'react';

interface UserTimerReturn {
    secondsLeft: number;
    isActive: boolean;
    startTimer: () => void;
}

export const useTimer = (initialSeconds: number = 60): UserTimerReturn => {
    const [secondsLeft, setSecondsLeft] = useState(0);
    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        if (!isActive || secondsLeft <= 0) {
            setIsActive(false);
            return;
        }

        const intervalId = setInterval(() => {
            setSecondsLeft((prevSeconds) => prevSeconds - 1);
        }, 1000);

        return () => clearInterval(intervalId);
    }, [isActive, secondsLeft]);

    const startTimer = useCallback(() => {
        setSecondsLeft(initialSeconds);
        setIsActive(true);
    }, [initialSeconds]);

    return { secondsLeft, isActive, startTimer };
};
